export const environment = {
  production: true,
  msal: {
    clientId: "ef3a714f-011a-44d6-8658-a351bc63be45", // PPE testing environment
    authority:
      "https://login.microsoftonline.com/08276a51-91c9-4b3c-a82a-5979fb1800e1", // PPE testing environment.
    redirectUri: "https://dev.mynadel.com",
    postLogoutRedirectUri: "https://dev.mynadel.com",
    graphUrl: "https://graph.microsoft.com/v1.0",
    scope: "ef3a714f-011a-44d6-8658-a351bc63be45/JNIPortal",
  },
  baseUrl: "https://api-jni-portal-core-dev.azurewebsites.net/api",
  tinyMceAPIKey: "bd3bt1xp079z3gj53maywuhbe8l2hxq9zkrbfj85xvoe8g9j",
  envName: "Dev",
  buildNumber: "#{BUILD_NUMBER}#",
};
